import { Earth, LocateFixed, MapPin, Phone } from "lucide-react";

export default function InstituteDetails({ data }) {
  const stripHtml = (html) => {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };
  return (
    <div className="space-y-6 font-inter">
      {/* ================= Institute Overview ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6 relative overflow-hidden">
        <h3 className="text-[#572575] font-bold text-lg mb-6 flex items-center gap-2">
          <span>
            <img src="/courseDetails/Name.png" alt="name" />
          </span>{" "}
          Institute Overview
        </h3>

        <div className="grid grid-cols-2 gap-x-16 gap-y-6 text-[13px]">
          <Info
            label="Institute Name"
            value={data.instituteDetails.university_name}
          />
          <Info
            label="Institute Type"
            value={data.instituteDetails.institute_type}
          />
          <Info label="Campus" value={data.instituteDetails.campus_name} />
          <Info
            label="SIEC Represented"
            value={data.instituteDetails.siec_rep}
          />
          <Info label="ARWO Ranking" value={data.instituteDetails.arwu_rank} />
          <Info
            label="Times Ranking"
            value={data.instituteDetails.times_rank}
          />
          <Info
            label="US Ranking"
            value={data.institute_details.us_news_rank}
          />
          <Info
            label="QS Ranking"
            value={data.institute_details.qs_world_rank}
          />
        </div>

        {/* Right Illustration */}
        <img
          src="/courseDetails/institute.png"
          alt="institute"
          className="absolute right-6 top-20 w-28 opacity-80 pointer-events-none"
        />
      </div>

      {/* ================= About Institute ================= */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6 relative overflow-hidden">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-[#572575] font-bold text-lg flex items-center gap-2">
            <span>
              {" "}
              <img src="/courseDetails/about.png" alt="about" />
            </span>{" "}
            About Institute
          </h3>

          <span className="bg-[#FFFCF5] border text-[#BE7603] text-sm font-semibold px-4 py-2 rounded-md flex items-center gap-1">
            <Earth color={"#BE7603"} size={20} /> No. of International Students
            :{" "}
            <span className="text-black">
              {data.instituteDetails.no_of_int_students}
            </span>
          </span>
        </div>

        <p className="text-sm text-black leading-relaxed mb-5 max-w-4xl">
          {data.institute_details.about_univ}
        </p>

        {/* Main Campus Box */}
        <div className="bg-[#FFFCF5] border-l-4 border-[#BE7603] rounded-lg p-4  max-w-xl">
          <p className="font-semibold text-md text-[#BE7603] mb-2">
            Main Campus :
          </p>

          <div className="space-y-1 text-gray-700 text-sm">
            <p className="flex items-center gap-2">
              <MapPin color={"#BE7603"} size={20} />
              {stripHtml(data.instituteDetails.campus_address)}
            </p>
            <p className="flex items-center gap-2">
              <Phone color="#BE7603" size={20} /> +1925-685-1230
            </p>
            <p className="flex items-center gap-2">
              {" "}
              <LocateFixed color={"#BE7603"} size={22} /> Pin code : 945678
            </p>
          </div>
        </div>

        {/* Decorative Shape */}
        <div className="absolute right-[-40px] bottom-[-40px] w-40 h-40 bg-orange-100 rounded-full opacity-40"></div>
      </div>
    </div>
  );
}

/* ================= Reusable Info ================= */
function Info({ label, value }) {
  return (
    <div>
      <p className="text-gray-400 mb-1">{label}</p>
      <p className="font-semibold text-gray-800">{value}</p>
    </div>
  );
}
